import { mapGetters } from 'vuex'
import { EventBus } from '@/services/EventBus'
import Player from '@/components/player/Player.vue'
import Modal from '@/components/modal/Modal.vue'

export default {
    name: 'Cams',
    data() {
        return {
            dragging: false,
            info: {
                show: false,
            }
        }
    },
    created() {
        EventBus.$on('cam:dragstart', this.onDragstart)
        EventBus.$on('cam:dragend', this.onDragend)
    },
    beforeDestroy() {
        EventBus.$off('cam:dragstart', this.onDragstart)
        EventBus.$off('cam:dragend', this.onDragend)
    },
    computed: {
        ...mapGetters({
            view: 'getActiveView',
            mode: 'getMode',
            map: 'getActiveMap',
            grid: 'getActiveGrid'
        }),
        cams() {
            return this.view ? this.view.cams : []
        },
        isMap() {
            return this.$route.params.mapId && this.$route.params.mapGroupId
        },
        playerData() {
            return {
                mode: this.mode,
                layout: this.grid.value,
                camera_list: this.cams.map(cam => cam.id),
            }
        }
    },
    methods: {
        add(data) {
            this.$store.commit('addCamsIntoView', {
                camIds: [data.camera_id],
                viewId: this.view.id
            })
        },
        remove(cam) {
            this.$store.commit('removeCamFromView', {
                camId: cam,
                viewId: this.view.id
            })
        },
        onDragstart() {
            this.dragging = true
        },
        onDragend() {
            this.dragging = false
        }
    },
    components: {
        Player,
        Modal,
    }
}



// WEBPACK FOOTER //
// ./src/modules/cams/cams.js